import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=cfa04114&scoped=true"
import script from "./sendMessage.vue?vue&type=script&lang=js"
export * from "./sendMessage.vue?vue&type=script&lang=js"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=cfa04114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa04114",
  null
  
)

export default component.exports